import { IPermissions } from "@/store/modules/auth/types";

export interface IFlowState {
  schedules: IFlowSchedules | null;
  subject: string | null;
  goto?: string;
  wait: number | null;
  step: FlowStep | null;
  etl: boolean | null;
}

export enum FlowStatus {
  SectionStarted,
  ClockRunning,
}

export enum FlowStep {
  Wait = "wait",
  Section = "section",
  Review = "review",
  Done = "done",
}

export interface IFlowSchedules {
  [key: string]: IFlowSchedule;
}

export interface IFlowSchedule {
  section_id: number;
  test_num: number;
  num: number;
  subject: string;
  ct: number;
  human_time: string;
  is_completed: 1 | 0;
}
